import script from "./arrvDeptList.vue?vue&type=script&setup=true&lang=js"
export * from "./arrvDeptList.vue?vue&type=script&setup=true&lang=js"

import "./arrvDeptList.vue?vue&type=style&index=0&id=69669cb4&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69669cb4"]])

export default __exports__